import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from '../SocialLinks';

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <SocialLinks containerClass="social-media" />
        <div className="footer-links">
          <p>&copy; {new Date().getFullYear()} Burger Barn. All rights reserved.</p>
          <Link to="/privacy-policy" className="privacy-link">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;